var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigiscapeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 80,
    y1: 13.49,
    x2: 80,
    y2: 146.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55efc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35dab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#18c7a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#06bc97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00b894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 80,
    y1: 52.91,
    x2: 80,
    y2: 146.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6fb6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#4fa7f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#359aee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2190e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1389e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0b85e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0984e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 79.2,
    y1: 97.41,
    x2: 79.53,
    y2: 148.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a29bfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8174f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c5ce7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 49.87,
    y1: 25.23,
    x2: 49.87,
    y2: 45.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeaa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fee8a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fdd886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fdce74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcb6e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.98,13.49h-12.09s-20.49,0-20.49,0c-6.16,0-11.15,4.99-11.15,11.15v110.72c0,6.16,4.99,11.15,11.15,11.15h33.83c37.21,0,67.38-30.71,66.49-68.11-.86-36.31-31.42-64.91-67.74-64.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.25,68.63v66.74c0,6.16,4.99,11.15,11.15,11.15h33.83c37.21,0,67.38-30.71,66.49-68.11-.21-8.73-2.15-17.01-5.46-24.57-7.4,14.31-15.26,18.52-20.68,19.91-21.7,5.57-39.5-25.07-63.66-20.34-10.42,2.04-17.61,9.8-21.68,15.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.25,114.73v20.64c0,6.16,4.99,11.15,11.15,11.15h33.83c32.08,0,58.91-22.84,65.14-53.11-5.32,4-14.46,9.77-26.66,11.6-20.47,3.08-31.26-7.65-51.23-5.3-7.52.88-18.93,3.93-32.23,15.02Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.87,
    cy: 35.29,
    r: 10.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiscapeColor);
export default __webpack_public_path__ + "static/media/digiscape-color.911c70483b2b4d461b883e2dd9ae8207.svg";
export { ForwardRef as ReactComponent };